import axios from "axios";
import { API_BASE_URL } from "../config";
import { getAuthHeaders } from "./developerApi";

const baseUrl = `${API_BASE_URL}/integrations/nova-poshta`;

export const getNovaPoshtaGlobalSettings = async () => {
    const response = await axios.get(`${baseUrl}/global-settings`, getAuthHeaders());
    return response.data;
};

export const updateNovaPoshtaGlobalSettings = async (payload) => {
    const response = await axios.put(`${baseUrl}/global-settings`, payload, getAuthHeaders());
    return response.data;
};

export const getNovaPoshtaLegalEntities = async () => {
    const response = await axios.get(`${baseUrl}/legal-entities`, getAuthHeaders());
    return response.data || [];
};

export const updateNovaPoshtaLegalEntitySettings = async (businessOrganizationId, payload) => {
    const response = await axios.put(
        `${baseUrl}/legal-entities/${businessOrganizationId}`,
        payload,
        getAuthHeaders(),
    );
    return response.data;
};

export const createNovaPoshtaSenderPoint = async (businessOrganizationId, payload) => {
    const response = await axios.post(
        `${baseUrl}/legal-entities/${businessOrganizationId}/sender-points`,
        payload,
        getAuthHeaders(),
    );
    return response.data;
};

export const updateNovaPoshtaSenderPoint = async (businessOrganizationId, pointId, payload) => {
    const response = await axios.put(
        `${baseUrl}/legal-entities/${businessOrganizationId}/sender-points/${pointId}`,
        payload,
        getAuthHeaders(),
    );
    return response.data;
};

export const importNovaPoshtaEnvSettings = async (payload) => {
    const response = await axios.post(`${baseUrl}/import-env`, payload, getAuthHeaders());
    return response.data;
};

export const discoverNovaPoshtaLegalEntityRefs = async (businessOrganizationId, payload = {}) => {
    const response = await axios.post(
        `${baseUrl}/legal-entities/${businessOrganizationId}/discovery`,
        payload,
        getAuthHeaders(),
    );
    return response.data;
};

export const checkNovaPoshtaLegalEntityWms = async (businessOrganizationId) => {
    const response = await axios.get(
        `${baseUrl}/legal-entities/${businessOrganizationId}/wms-check`,
        getAuthHeaders(),
    );
    return response.data;
};
